export default {"src":"/_next/static/media/logo-nh-white.5316e164.svg","height":58,"width":303};